import { LgpResultsContainerQuery } from "../types";
import { IMotorsportsTabsSwitch } from '@sky-it-livedata/livedata-sports-design-system';
import { isValidLgpResultsContainer } from './typeguards';
import { RaceSessionType } from "../../../types/lgp";
import { ErrorName, WidgetError } from "../../../utils/errors";
import { CreateLgpResultsContainerWidgetInputSchema } from "appsync";


export default (obj: LgpResultsContainerQuery): IMotorsportsTabsSwitch => {
  if (isValidLgpResultsContainer(obj)) {
    CreateLgpResultsContainerWidgetInputSchema().parse(obj.data.getLgpResultsContainerWidget, {reportInput: true});
    const { gpId, seasonAndCompId, __typename, createdAt, updatedAt, seasonId, competitionId, ...sessionObj } =
      obj.data.getLgpResultsContainerWidget;

    const sessions: IMotorsportsTabsSwitch['sessions'] = Object.entries(sessionObj)
      .filter(([key, _]) => key !== 'G')
      .filter(([_, value]) => Boolean(value?.ssi))
      .map(([key, value]) => ({
        sessionType: key as RaceSessionType,
        customDataAttributes: (value!.customDataAttributes) as object,
        ssi: value!.ssi as string,
        startDateTime: (value!.startDateTime) as string,
      }))
      .sort((a, b) => Date.parse(b.startDateTime) - Date.parse(a.startDateTime))
      .map((session) => {
        const { startDateTime, ...rest } = session;
        return rest;
      });

    return {
      hasLgpAnalytics: true,
      sessions,
      isLgp: true,
    };
  } else {
      throw new WidgetError<ErrorName>({
        name: 'NO_VALID_DATA',
        message: 'Invalid transformer input, Error in LgpResultsContainerQuery object',
        data: obj
      });
    }
};
